export var NewsletterMailStatus;
(function (NewsletterMailStatus) {
    NewsletterMailStatus["DRAFT"] = "DRAFT";
    NewsletterMailStatus["FAILED"] = "FAILED";
    NewsletterMailStatus["QUEUED"] = "QUEUED";
    NewsletterMailStatus["CHECKS"] = "CHECKS";
    NewsletterMailStatus["BLACKLIST"] = "BLACKLIST";
    NewsletterMailStatus["PREPARING"] = "PREPARING";
    NewsletterMailStatus["SENDING"] = "SENDING";
    NewsletterMailStatus["CANCELED"] = "CANCELED";
    NewsletterMailStatus["PAUSED"] = "PAUSED";
    NewsletterMailStatus["DONE"] = "DONE";
    NewsletterMailStatus["ARCHIVING"] = "ARCHIVING";
    NewsletterMailStatus["ARCHIVED"] = "ARCHIVED";
    NewsletterMailStatus["RELEASED"] = "RELEASED";
    NewsletterMailStatus["SCHEDULED"] = "SCHEDULED";
})(NewsletterMailStatus || (NewsletterMailStatus = {}));
export var NewsletterMailType;
(function (NewsletterMailType) {
    NewsletterMailType["TRANSACTIONAL"] = "TRANSACTIONAL";
    NewsletterMailType["LIFECYCLE"] = "LIFECYCLE";
})(NewsletterMailType || (NewsletterMailType = {}));
